export const FTI_STATUS_OPTIONS = [
  { label: "Issued", value: 1 },
  { label: "Cancelled", value: 2 },
];

export const FTI_STATUS_STYLES = {
  issued: { color: "#0F875B", backgroundColor: "#E1FBF2" },
  cancelled: { color: "#C42B1C", backgroundColor: "#FFE7E3" },
};
